import { render, staticRenderFns } from "./faturas.vue?vue&type=template&id=2cd5631c&"
import script from "./faturas.vue?vue&type=script&lang=js&"
export * from "./faturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports